export class GroupChatActiveAgents{    
    agentFullName : string[];
    agentEmailId : string[];
}